<script setup>

</script>
<template>
  <i class="aside-menu drug-type">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="10.1042" y="0.958862" width="9.11726" height="16.2085" rx="4.55863" transform="rotate(30 10.1042 0.958862)" stroke="url(#paint0_linear_284_188)" stroke-width="1.8"/>
      <line x1="5.99565" y1="8.07522" x2="13.8914" y2="12.6339" stroke="url(#paint1_linear_284_188)" stroke-width="1.8"/>
      <defs>
        <linearGradient id="paint0_linear_284_188" x1="10.1042" y1="9.06309" x2="19.2215" y2="9.06309" gradientUnits="userSpaceOnUse">
          <stop stop-color="#366FFF"/>
          <stop offset="1" stop-color="#6B95FF"/>
        </linearGradient>
        <linearGradient id="paint1_linear_284_188" x1="5.29565" y1="9.28766" x2="13.1914" y2="13.8463" gradientUnits="userSpaceOnUse">
          <stop stop-color="#366FFF"/>
          <stop offset="1" stop-color="#6B95FF"/>
        </linearGradient>
      </defs>
    </svg>
  </i>
</template>
<style scoped>
.aside-menu{
  height: 20px;
}
</style>